module.exports = __webpack_public_path__ + "static/NotoSans-Regular-21f6235482ecdf67217dfa18483f7716.ttf";